<template>
    <div>
                <base-header style="background: rgba(79, 47, 129, 1);
background: radial-gradient(circle, rgba(79, 47, 129, 1) 25%, rgba(79, 47, 129, 0.73) 100%);" class="pb-6 pb-8 pt-5 pt-md-5">
            <!-- Card stats -->
            <!-- <div class="row">
              <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0">Icons</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            <!-- </div> -->
        </base-header>

        <div class="container-fluid mt--7" >
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0" v-if="textleft">Actual Dates</h3>
                            <h3 class="mb-0" v-else style="text-align:right;">التواريخ الفعلية</h3>
                        </div>
                        <div class="card-body">
                           <form> <!--v-on:submit.prevent="onSubmit(title, message, );">-->


                             <div class="row">
                               <div v-if ="textleft" class="col-md-6">
                                     <!-- <h3>Select Entity</h3> -->
                                     <base-dropdown >
                                     <!-- <base-button slot="title" type="secondary" class="dropdown-toggle">
                                        Select Entity
                                      </base-button> -->
                                      <base-button v-if="assignments" id="entityDropDown"  slot="title" type="secondary" @change="onChangeAssignment($event)" class="dropdown-toggle" v-model="assignment">
                                        {{assignment}}
                                      </base-button>
                                         <!-- <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                           {{entity}}
                                         </base-button> -->
                                         <span v-for="(fieldName, pos1) in assignments" :key="pos1" class="dropdown-item" :value="fieldName['title']" v-on:click="onChangeAssignment">{{fieldName["title"]}}</span>
                                         <!-- <base-button class="dropdown-item" value="Finance" v-on:click="onChange">Finance</base-button>
                                         <base-button class="dropdown-item" value="Operations" v-on:click="onChange">Operations</base-button>
                                         <base-button class="dropdown-item" value="Accounting" v-on:click="onChange">Accounting</base-button>  -->

                                       </base-dropdown>
                                   </div>
                                   <div v-else class="col-md-6 text-right">
                                         <!-- <h3>Select Entity</h3> -->
                                         <base-dropdown >
                                         <!-- <base-button slot="title" type="secondary" class="dropdown-toggle">
                                            Select Entity
                                          </base-button> -->
                                          <base-button v-if="assignments" id="entityDropDown"  slot="title" type="secondary" @change="onChangeAssignment($event)" class="dropdown-toggle" v-model="assignment">
                                            {{assignment}}
                                          </base-button>
                                             <!-- <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                               {{entity}}
                                             </base-button> -->
                                             <span v-for="(fieldName, pos1) in assignments" :key="pos1" class="dropdown-item" :value="fieldName['title']" v-on:click="onChangeAssignment">{{fieldName["title"]}}</span>
                                             <!-- <base-button class="dropdown-item" value="Finance" v-on:click="onChange">Finance</base-button>
                                             <base-button class="dropdown-item" value="Operations" v-on:click="onChange">Operations</base-button>
                                             <base-button class="dropdown-item" value="Accounting" v-on:click="onChange">Accounting</base-button>  -->

                                           </base-dropdown>
                                       </div>
                             <!-- <div class="col-md-6"> -->

                                   <!-- <h3>Select Entity</h3>
                                   <base-dropdown>
                                     <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                         {{entity}}
                                       </base-button>
                                       <base-button v-for="(fieldName, pos1) in entities" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChange">{{fieldName}}</base-button>
                                     </base-dropdown> -->
                                 <!-- </div> -->
                               </div>

                          <div class="row">
                            <div v-if ="textleft" class="col-md-6">
                                  <!-- <h3>Select Entity</h3> -->
                                  <base-dropdown >
                                  <!-- <base-button slot="title" type="secondary" class="dropdown-toggle">
                                     Select Entity
                                   </base-button> -->
                                   <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                     {{entity}}
                                   </base-button>
                                      <!-- <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                        {{entity}}
                                      </base-button> -->
                                      <span v-for="(fieldName, pos1) in entities" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChange">{{fieldName}}</span>
                                      <!-- <base-button class="dropdown-item" value="Finance" v-on:click="onChange">Finance</base-button>
                                      <base-button class="dropdown-item" value="Operations" v-on:click="onChange">Operations</base-button>
                                      <base-button class="dropdown-item" value="Accounting" v-on:click="onChange">Accounting</base-button>  -->

                                    </base-dropdown>
                                </div>
                                <div v-else class="col-md-6 text-right">
                                      <!-- <h3>Select Entity</h3> -->
                                      <base-dropdown >
                                      <!-- <base-button slot="title" type="secondary" class="dropdown-toggle">
                                         Select Entity
                                       </base-button> -->
                                       <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                         {{entity}}
                                       </base-button>
                                          <!-- <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                            {{entity}}
                                          </base-button> -->
                                          <span v-for="(fieldName, pos1) in entities" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChange">{{fieldName}}</span>
                                          <!-- <base-button class="dropdown-item" value="Finance" v-on:click="onChange">Finance</base-button>
                                          <base-button class="dropdown-item" value="Operations" v-on:click="onChange">Operations</base-button>
                                          <base-button class="dropdown-item" value="Accounting" v-on:click="onChange">Accounting</base-button>  -->

                                        </base-dropdown>
                                    </div>
                          <!-- <div class="col-md-6"> -->

                                <!-- <h3>Select Entity</h3>
                                <base-dropdown>
                                  <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                      {{entity}}
                                    </base-button>
                                    <base-button v-for="(fieldName, pos1) in entities" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChange">{{fieldName}}</base-button>
                                  </base-dropdown> -->
                              <!-- </div> -->
                            </div>

                            <div class="row">
                              <div v-if ="textleft" class="col-md-6">
                                    <!-- <h3>Select Entity</h3> -->
                                    <base-dropdown >
                                    <!-- <base-button slot="title" type="secondary" class="dropdown-toggle">
                                       Select Entity
                                     </base-button> -->
                                     <base-button v-if="phases" id="phaseDropDown"  slot="title" type="secondary" @change="onChangePhase($event)" class="dropdown-toggle" v-model="phase">
                                       {{phase}}
                                     </base-button>
                                        <!-- <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                          {{entity}}
                                        </base-button> -->
                                        <span v-for="(fieldName, pos1) in phases" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChangePhase">{{fieldName.name}}</span>
                                        <!-- <base-button class="dropdown-item" value="Finance" v-on:click="onChange">Finance</base-button>
                                        <base-button class="dropdown-item" value="Operations" v-on:click="onChange">Operations</base-button>
                                        <base-button class="dropdown-item" value="Accounting" v-on:click="onChange">Accounting</base-button>  -->

                                      </base-dropdown>
                                  </div>
                                  <div v-else class="col-md-6 text-right">
                                        <!-- <h3>Select Entity</h3> -->
                                        <base-dropdown >
                                        <!-- <base-button slot="title" type="secondary" class="dropdown-toggle">
                                           Select Entity
                                         </base-button> -->
                                         <base-button v-if="phases" id="phaseDropDown"  slot="title" type="secondary" @change="onChangePhase($event)" class="dropdown-toggle" v-model="phase">
                                           {{phase}}
                                         </base-button>
                                            <!-- <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                              {{entity}}
                                            </base-button> -->
                                            <span v-for="(fieldName, pos1) in phases" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChangePhase">{{fieldName.name}}</span>
                                            <!-- <base-button class="dropdown-item" value="Finance" v-on:click="onChange">Finance</base-button>
                                            <base-button class="dropdown-item" value="Operations" v-on:click="onChange">Operations</base-button>
                                            <base-button class="dropdown-item" value="Accounting" v-on:click="onChange">Accounting</base-button>  -->

                                          </base-dropdown>
                                      </div>
                            <!-- <div class="col-md-6"> -->

                                  <!-- <h3>Select Entity</h3>
                                  <base-dropdown>
                                    <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                        {{entity}}
                                      </base-button>
                                      <base-button v-for="(fieldName, pos1) in entities" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChange">{{fieldName}}</base-button>
                                    </base-dropdown> -->
                                <!-- </div> -->
                              </div>
                            <!-- <br>
                            <h3>Current Phase</h3>
                            <h4>Phase : <span>{{current_phase_name}}</span></h4>
                            <h4>Scheduled Date : <span>{{current_phase_date}}</span></h4>

                            <br> -->

                            <h3 v-if="textleft">Set Actual Start Date</h3>
                            <h3 v-else style="text-align:right;">حدد تاريخ البدء الفعلي</h3>

                                <base-input dir="ltr" v-if="start_date_set"  style="width:150px;text-align:right;" disabled>
                                    <flat-picker v-if="start_date_set" disabled slot-scope="{focus, blur}"
                                                 @on-open="focus"
                                                 @on-close="blur"
                                                 @on-change="startDatePicked()"
                                                 :config="{allowInput: true}"
                                                 class="form-control datepicker"
                                                 v-model="start_date" style="color:green;font-size: 12px;height: 43px;">
                                    </flat-picker>

                                    <flat-picker v-else slot-scope="{focus, blur}"
                                                 @on-open="focus"
                                                 @on-close="blur"
                                                 @on-change="startDatePicked()"
                                                 :config="{allowInput: true}"
                                                 class="form-control datepicker"
                                                 v-model="start_date" style="font-size: 12px;height: 43px;">
                                    </flat-picker>

                                </base-input>
                                <base-input dir="ltr" v-else  style="width:150px;" disabled>

                                        <flat-picker  slot-scope="{focus, blur}"
                                                     @on-open="focus"
                                                     @on-close="blur"
                                                     @on-change="startDatePicked()"
                                                     :config="{allowInput: true}"
                                                     class="form-control datepicker"
                                                     v-model="start_date" style="font-size: 12px;height: 43px;">
                                        </flat-picker>
                                    </base-input>

                                <div v-if="start_date_set || start_date_picked">
                                  <h3 v-if="textleft">Set Actual End Date</h3>
                                  <h3 v-else style="text-align : right;">حدد تاريخ الانتهاء الفعلي</h3>
                                    <base-input dir="ltr" v-if="end_date_set" style="width:150px;">
                                          <flat-picker v-if="end_date_set"  disabled slot-scope="{focus, blur}"
                                                       @on-open="focus"
                                                       @on-close="blur"
                                                       @on-change="endDatePicked()"
                                                       :config="{allowInput: true}"
                                                       class="form-control datepicker"
                                                       v-model="end_date" style="color:green; font-size: 12px;height: 43px;">
                                          </flat-picker>

                                          <flat-picker v-else slot-scope="{focus, blur}"
                                                       @on-open="focus"
                                                       @on-close="blur"
                                                       @on-change="endDatePicked()"
                                                       :config="{allowInput: true}"
                                                       class="form-control datepicker"
                                                       v-model="end_date" style=" font-size: 12px;height: 43px;">
                                          </flat-picker>


                                      </base-input>
                                      <base-input dir="ltr"  v-else  style="width:150px;">
                                              <flat-picker slot-scope="{focus, blur}"
                                                           @on-open="focus"
                                                           @on-close="blur"
                                                           @on-change="endDatePicked()"
                                                           :config="{allowInput: true}"
                                                           class="form-control datepicker"
                                                           v-model="end_date" style=" font-size: 12px;height: 43px;">
                                              </flat-picker>
                                      </base-input>
                                    </div>
                                <!-- <br> -->
                            <!-- <fieldset class="form-group">
                              <div class="row">
                              <div class="col-md-6">
                                <h3>Enter Note</h3>
                                  <base-input alternative placeholder="Note" v-model="note" ></base-input>
                              </div>
                            </div>
                            </fieldset> -->

                            <fieldset class="form-group">
                            <div class="row">
                              <div v-if="textleft" class="col-md-6">
                                 <base-button type="success" v-on:click="onSubmit">{{buttontitle}}</base-button>
                              </div>
                              <div v-else class="col-md-6 text-right">
                                 <base-button type="success" v-on:click="onSubmit">{{buttontitle}}</base-button>
                              </div>
                            </div>
                          </fieldset>
                          </form>
<!--                                 <div class="col-lg-3 col-md-6"
                                     v-for="(icon, index) in icons" :key="icon.name + index">
                                    <button type="button"
                                            v-b-tooltip.hover.top
                                            :title="icon.name"
                                            v-clipboard:copy="icon.name"
                                            v-clipboard:success="onCopy"
                                            class="btn-icon-clipboard" data-clipboard-text="air-baloon">
                                        <div>
                                            <i :class="icon.name"></i>
                                            <span>{{icon.name.substring(6)}}</span>
                                        </div>
                                    </button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import { mapState } from "vuex";
  import { UPLOAD_DATA, GET_ENTITIES, GET_PHASES, SET_PHASE_DATE, SUPERADMIN_GET_ASSIGNMENTS } from "@/store/actions.type";
  import store from "@/store";
  import { mapGetters } from "vuex";
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import UserService from "@/common/user.service";
  Vue.use(VueClipboard)
  export default {
    directives: {
      'b-tooltip': BTooltipDirective
    },
    components: {flatPicker},
    data() {
      return {
        textleft : UserService.getLanguage() === "ltr" ? true : false,
        report_type : "",
        buttontitle : UserService.getLanguage() === "ltr" ? 'Set Date' : "حدد التاريخ",
        current_phase_date :'',
        current_phase_name : '',
        note : '',
        budget : '',
        file : '',
        assignments : [],
        // entity : store.getters.entitiesState ? store.getters.entitiesState[0] : '',
        assignment : UserService.getLanguage() === "ltr" ? "Select Assignment" : "حدد المهمة",
        entity : UserService.getLanguage() === "ltr" ? "Select Entity" : "حدد وحدة العمل" ,
        entities : store.getters.entitiesState,
        phase : UserService.getLanguage() === "ltr" ? "Select Phase" : "حدد المرحلة",
        phases : [],
        timeslot : 'Human Resources',
        message : '',
        d_counter : 0,
        d_counter1 : 0,
        tiers : {
          all : true,
          starter : false,
          silver : false,
          gold : false,
          platinum : false
        },
        // dates: {
          start_date: new Date().toISOString().split(" ")[0],
          start_date_set : false,
          start_date_picked : false,
          end_date: new Date().toISOString().split(" ")[0],
          end_date_set : false,
          end_date_picked : false
        // }
      }
    },
    // watch: {
    //    start_date: function (val) {
    //      if (this.d_counter === 1) {
    //         console.log("START DATE CHANGE : "+ val);
    //      }
    //      else if (this.d_counter === 0) {
    //        this.d_counter = 1;
    //      }
    //
    //
    //      // this.start_date = val ;
    //    },
    //    end_date: function (val) {
    //      if (this.d_counter1 === 1) {
    //         console.log("END DATE CHANGE : "+ val);
    //      }
    //      else if (this.d_counter1 === 0) {
    //        this.d_counter1 = 1;
    //      }
    //
    //      // this.end_date = val ;
    //    }
    //  },
    computed: {
        ...mapGetters(["isAuthenticated", "entitiesState"])
        // ,
        // subscribers() {
        //     console.log(this.$route.params.subscribers);
        //   return this.$route.params.subscribers;
        // }
      },
        mounted() {
          Promise.all([
            store.dispatch(SUPERADMIN_GET_ASSIGNMENTS, "")
          ]).then((data) => {
            console.log(data[0]['data']);
              this.loaded = true;

              this.assignments = data[0]['data'];
              // this.getCurrentPhase(data[0]['data'][0]);
              // this.teammembers = teamMembers;
              // console.log(this.stores);
              // console.log(this.visitsdata);
              // this.initBigChart(this.stores[0]);
              // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
              // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
              // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
          });

    },
    methods: {
      startDatePicked() {
        this.start_date_picked = true;
      },
      endDatePicked() {
        this.end_date_picked = true;

      },
      onSelect() {
          const file1 = this.$refs.file.files[0]
          this.file = file1;
      },
      onSubmit() {
        if (this.file !== '') {
          this.buttontitle = "Uploading..";
        }

        console.log("TITLE : " + this.title);
        // console.log("MESSAGE : " + this.message);
        // console.log("TIMESLOT : " + this.timeslot);
        // console.log("TIERS : ");
        // console.log(this.tiers);
        // console.log("DATE : " + this.dates.simple);
            // if (email !== '' && password !== '') {
            //     this.localerrors = null;

            if (this.current_phase_name !== "" && this.start_date !== "" && this.end_date !== "" && this.entity !== "") {
              // console.log((new Date(this.dates.start_date).getDate()+" "+new Date().getDate()+" "+new Date(this.dates.start_date).getMonth()+ " "+new Date().getMonth()+ " "+new Date(this.dates.start_date).getFullYear()+ " "+new Date().getFullYear()));
              //
              // console.log("IS START DATE SET : " + isStartDateSet);
              // console.log("IS END DATE SET : " + isEndDateSet);
              let validation = true;
              if ((this.start_date_picked || this.start_date_set) && this.end_date_picked) {
                if (new Date(this.start_date) < new Date(this.end_date)) {
                  validation = true;
                }
                else {
                  validation = false;
                }
              }

                if (validation) {
                  let isStartDateSet = false;
                  if (this.start_date_picked) {
                    isStartDateSet = true;
                    if (this.start_date_set) {
                      isStartDateSet = false;
                    }
                  }
                  let isEndDateSet = false;
                  if (this.end_date_picked){
                    isEndDateSet = true;
                    if (this.end_date_set) {
                      isEndDateSet = false;
                    }
                  }

                  // if (!this.dates.start_date_set && isEndDateSet) {
                  //   if (this.textleft) {
                  //     this.$notify({
                  //           type: 'warning',
                  //           title: 'End date cannot be set without Start date being set'
                  //         })
                  //   }
                  //   else {
                  //     this.$notify({
                  //           type: 'warning',
                  //           title: 'لا يمكن تعيين تاريخ الانتهاء دون تعيين تاريخ البدء'
                  //         })
                  //   }
                  // }
                  let isSet = false;
                  if ((!this.start_date_set && !isStartDateSet) && (!this.end_date_set && isEndDateSet)) {
                    if (this.textleft) {
                      this.$notify({
                            type: 'warning',
                            title: 'End date cannot be set without Start date being set'
                          })
                    }
                    else {
                      this.$notify({
                            type: 'warning',
                            title: 'لا يمكن تعيين تاريخ الانتهاء دون تعيين تاريخ البدء'
                          })
                    }
                  }
                  else {
                    if (isStartDateSet || isEndDateSet) {


                      let formData = {'phase_name' : this.current_phase_name, 'entity' : this.entity, 'start_date' : this.start_date.split("T")[0],'end_date' : this.end_date.split("T")[0], 'assignment_id' : UserService.getAssignmentId(), 'start_date_set' : Number(isStartDateSet), 'end_date_set' : Number(isEndDateSet)};


                      Promise.all([
                        store.dispatch(SET_PHASE_DATE, formData),

                      ]).then(() => {
                          this.isLoading = false;
                          this.$notify({
                            type: 'success',
                            title: 'Phase Date Set Successfully'
                          });
                          this.$router.push({ name: "overview" })
                      });
                    }
                    else {
                      if (this.textleft) {
                        this.$notify({
                              type: 'warning',
                              title: 'Please fill in all required fields'
                            })
                      }
                      else {
                        this.$notify({
                              type: 'warning',
                              title: 'يرجى تعبئة جميع الحقول المطلوبة'
                            })
                      }
                    }
                  }


                }
                else {
                  if (this.textleft) {
                    this.$notify({
                        type: 'warning',
                        title: 'End date cannot be older than current date !'
                      });
                  }
                  else {
                    this.$notify({
                      type: 'warning',
                      title: '!لا يمكن أن تكون تواريخ الانتهاء أقدم من التاريخ الحالي'
                    });
                  }
                }
              }
              else {
                if (this.textleft) {
                  this.$notify({
                        type: 'warning',
                        title: 'Please fill in all required fields'
                      })
                }
                else {
                  this.$notify({
                        type: 'warning',
                        title: 'يرجى تعبئة جميع الحقول المطلوبة'
                      })
                }
              }

        },

        onChangeAssignment(event) {
            let map = {};
            for (let y = 0; y < this.assignments.length; y++) {
              map[this.assignments[y].title]= this.assignments[y].id;
            }
            this.assignment = event.target.innerText;
            this.entity = UserService.getLanguage() === "ltr" ? "Select Entity" : "حدد وحدة العمل";
            this.phase = UserService.getLanguage() === "ltr" ? "Select Phase" : "حدد المرحلة";
            Promise.all([
              store.dispatch(GET_ENTITIES, map[event.target.innerText])
            ]).then((data) => {
              console.log(data[0]['data']);
                this.loaded = true;

                this.entities = data[0]['data'];
                // this.getCurrentPhase(data[0]['data'][0]);
                // this.teammembers = teamMembers;
                // console.log(this.stores);
                // console.log(this.visitsdata);
                // this.initBigChart(this.stores[0]);
                // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
                // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
                // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
            });

        },
      onChange(event) {
          // this.entity = event.target.value;
          this.entity = event.target.innerText;
          this.phase = UserService.getLanguage() === "ltr" ? "Select Phase" : "حدد المرحلة";

          this.getCurrentPhase(event.target.innerText);
          console.log(event);
      },
      onChangePhase(event) {

          // this.entity = event.target.value;
          this.phase = event.target.innerText;
          this.current_phase_name = event.target.innerText;
          for (let i = 0; i < this.phases.length; i++) {
            if (this.phases[i].name === event.target.innerText) {
              console.log(this.phases[i]);
              if (this.phases[i].actual_start_date !== "-") {
                  this.start_date = this.phases[i].actual_start_date;
                  this.start_date_set = true;
              }
              else {
                this.start_date = new Date().toISOString().split("T")[0];
                this.start_date_set = false;
              }

              console.log("START DATE SET ");
              console.log(this.start_date_set);
              if (this.phases[i].actual_end_date !== "-") {
                  this.end_date = this.phases[i].actual_end_date;
                  this.end_date_set = true;
              }
              else {
                this.end_date = new Date().toISOString().split("T")[0];
                this.end_date_set = false;
              }

              console.log("STARENDT DATE SET ");
              console.log(this.end_date_set);

            }
          }
          // this.getCurrentPhase(event.target.innerText);
          console.log(event);
      },
      getCurrentPhase(entity) {
        Promise.all([
          store.dispatch(GET_PHASES, [UserService.getAssignmentId(),entity])
        ]).then((data) => {
          console.log(data[0]['data']);
            this.phases = data[0]['data'];
            this.loaded = true;

            // this.current_phase_date = data[0]['data']['start_date'];
            // this.dates.simple = new Date(data[0]['data']['start_date']).toISOString().split(" ")[0];
            // this.current_phase_name = data[0]['data']['name'];



            // this.teammembers = teamMembers;
            // console.log(this.stores);
            // console.log(this.visitsdata);
            // this.initBigChart(this.stores[0]);
            // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
            // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
            // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
        });
      },
      onChangeRType(event) {
          this.report_type = event.target.value;
          console.log(event);
      },
      onCopy() {
        this.$notify({
          type: 'success',
          title: 'Copied to clipboard'
        })
      }
    }
  };
</script>
<style></style>
